export default class {
    constructor(apiService) {
        this.axiosInstance = apiService
    }

    one(buildKey) {
        return this.axiosInstance.get(`builds/${buildKey}`)
    }
}
